type ResponsiveMediaProps = Readonly<{
	view: 'mobile' | 'desktop';
	kind: 'image' | 'video';
	children: React.ReactNode;
}>;

export const ResponsiveMedia: React.FC<ResponsiveMediaProps> = ({ view, kind, children }) => {
	return (
		<div
			className={view === 'mobile' ? 'md:hidden' : 'hidden md:block'}
			data-testid={`impact-story-${kind}-${view}`}
			data-qa={`impact-story-${kind}-${view}`}
		>
			{children}
		</div>
	);
};
